export default __webpack_public_path__ + "images/4ea1cf1ff8dde0e7ea8fd14ba3d89124-charity_and_causes.png";